import { VideoCameraFront } from "@mui/icons-material";
import { IFeatures } from "@/utils/interfaces";
import { useSessionContext } from "@/contexts/SessionContext";
import { useViewContext } from "@/contexts/ViewContext";
import { useTeleconsultoriaContractContext } from "@/contexts/TeleconsultoriaContractContext";
import { useTeleconsultoriaProfile } from "src-next/modules/teleconsultoria/profile/TeleconsultoriaProfileContext";
import { TeleconsultoriaPage } from "./TeleconsultoriaPage";

export function useTeleconsultoria() {
  const { access } = useSessionContext();
  const { availableRoles } = useViewContext();
  const { contractTeleconsultoria } = useTeleconsultoriaContractContext();
  // Afiliada (recebe teleconsultoria) também vê o menu, mesmo sem a extensão.
  const { profile } = useTeleconsultoriaProfile();
  const isPractitioner = availableRoles?.includes("practitioner");
  const canClinic =
    availableRoles?.includes("manager") ||
    availableRoles?.includes("owner") ||
    availableRoles?.includes("associated");

  const configs: IFeatures = {
    active:
      access.type === "professional" &&
      // Contrato (prestadora) continua liberando; afiliação ativa também libera.
      (Boolean(contractTeleconsultoria) || profile.kind !== "none") &&
      (Boolean(isPractitioner) || Boolean(canClinic)),
    path: "/teleconsultoria",
    icon: VideoCameraFront,
    text: "Teleconsultoria",
    sideMenu: true,
    sideMenuIndex: 0,
    // Referência ESTÁVEL (não `() => <TeleconsultoriaPage />`): uma função nova a cada
    // render faz o roteador remontar a página quando um contexto pai atualiza
    // (ex.: refetch de Location ao abrir "Criar agenda"), fechando diálogos e
    // zerando abas/filtros. Mesmo padrão de ManagePractitioners.
    component: TeleconsultoriaPage,
  };

  return configs;
}
